import React from 'react';
import PasswordReset from './passwordreset';
import NoAccountForm from './noaccountform';
import GuestClient from '../profile/guestclient';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import { PleaseWaitSpinner } from "../utilctl";

import { TitleBox } from '@tsinternetsale/common';

var tr = require('ts-translate-js').default.boundTR;

export const LoginPanel = createClass({
    displayName: "LoginPanel",

    propTypes: {
        email: PropTypes.string,
        password: PropTypes.string,
        isGuestClientAuthorized: PropTypes.bool,
        isWhiteLabel: PropTypes.bool,
        onConnectSuccess: PropTypes.func,
        onChangeEmail: PropTypes.func,
        onChangePassword: PropTypes.func,
        onRegisterProfile: PropTypes.func,
        onContentChange: PropTypes.func,
        showGuestClientForm: PropTypes.func
    },

    getInitialState(){
        return {
            showFailedAuthMsg: false,
            showForgotPassword: false,
            processingLogin:false
        };
    },

    componentWillUnmount(){
        if (this.actionRequest != null) this.actionRequest.abort();
    },

    componentDidMount() {
        this.raiseContentChanged();
    },

    componentDidUpdate() {
        this.raiseContentChanged();
    },

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function () {
            if (this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    },

    handleOnConnect(e){
        e.preventDefault();
        this.setState({processingLogin:true});
        this.setState({showFailedAuthMsg:false});
        this.actionRequest = tsapp.mvcapi.postCtl("login/Login", {email:this.props.email, password:this.props.password})
        .success(
            function(data){
                this.props.onConnectSuccess();
            }.bind(this))
        .notSuccess(
            function(data){
                this.setState({processingLogin:false});
                this.setState({showFailedAuthMsg: true});
            }.bind(this));
    },

    handleOnChangeEmail(e){
        const email = (e != null) ? e.target.value : null;
        if(this.props.onChangeEmail)
            this.props.onChangeEmail(email);
    },

    handleOnChangePassword(e){
        this.props.onChangePassword(e.target.value);
    },

    handleOnChangeEmailPassword(e){
        this.setState({emailPassword : e.target.value});
    },

    handleOnResetOK(e){
        this.setState({showFailedSendResetEmail: false, showSuccessSendResetEmail: false});
    },

    handlePopupKeyPress(e){
        if (e.key === 'Enter') {
            this.handleOnFailedAuthOK();
        }
    },

    handlePopupResetKeyPress(e){
        if (e.key === 'Enter') {
            this.handleOnResetOK();
        }
    },

    handleOnRegisterProfile(e){
        e.preventDefault();
        this.props.onRegisterProfile();
    },

    displayGuestClientForm() {
        this.props.showGuestClientForm();
    },

    handleOnGuestClientCreation() {
        this.props.handleOnGuestClientCreated();
    },

    handleOnCancelGuestClientCreation() {
        // TODO: Ça sert tu vraiment à quelque chose ça? Le state showGuestClientForm semble être inutilisé.
        this.setState({ showGuestClientForm : false });
    },

    handleOnForgetPassword(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({showForgotPassword:true});
    },

    handleOnConfirmResetPassword() {
        this.handleOnChangeEmail(null);
        this.setState({showForgotPassword:false});
    },

    handleOnResetPasswordError() {
        this.setState({showFailedSendResetEmail:true});
    },
    
    handleOnCancelResetPassword(){
        this.setState({showForgotPassword:false});
    },

    render(){
        
        var failedAuthMsg = this.state.showFailedAuthMsg
            ? <div className="form-group"><div className="alert alert-danger text-center" style={{margin:"0"}} role="alert">{tr("login.failedauthmsg")}</div></div>
            : null;

        var loginButton = this.state.processingLogin
                        ? <div><PleaseWaitSpinner size="sm"/></div>
                        : <button className="btn btn-primary" type="submit">{tr("login.connection")}</button>;

        if (this.state.showForgotPassword == true) {
            return (
                <PasswordReset 
                    onChangeEmailPassword={this.handleOnChangeEmailPassword}
                    onConfirmResetPassword={this.handleOnConfirmResetPassword}
                    onCancelResetPassword={this.handleOnCancelResetPassword}
                    email={this.props.email}
                    integ={this.props.integ}/>
            );
        } else if (this.state.showGuestClientForm == true) {
            // TODO: Ça sert tu vraiment à quelque chose ça? Le state showGuestClientForm semble être inutilisé.
            return (
                <div className="row">
                    <GuestClient
                        guestClient={{
                            firstName: "",
                            lastName: "",
                            homePhone: "",
                            postalCode: "",
                            email: "",
                        }}
                        handleOnCreate={this.handleOnGuestClientCreation}
                        handleOnCancel={this.handleOnCancelGuestClientCreation}
                        showWholeForm={true}
                        onContentChange={this.props.onContentChange} />
                </div>
            );
        }

        return(
            <div className="row">
                <NoAccountForm
                    isWhiteLabel={this.props.isWhiteLabel}
                    handleOnRegisterProfile={this.handleOnRegisterProfile}
                    handleOnGuestClient={this.props.showGuestClientForm}
                    displayGuestClientButton={this.props.isGuestClientAuthorized} />

                <div className="col-xs-12 col-sm-5 col-md-5 col-lg-4">
                    <form onSubmit={this.handleOnConnect}>
                        <TitleBox title={tr("login.connection")}>
                            <div className="form-group">
                                <input className="form-control" type="text" ref={(input) => this.email = input} placeholder={tr("login.email")} onChange={this.handleOnChangeEmail} onKeyPress={this.handleKeyPress}></input>
                            </div>

                            <div className="form-group">
                                <input className="form-control" type="password"  placeholder={tr("login.password")} onChange={this.handleOnChangePassword} onKeyPress={this.handleKeyPress}></input>
                            </div>

                            <div className="form-group">
                                <p className="help-block"><a href="#" onClick={this.handleOnForgetPassword}>{tr("login.forgotpassword")}</a></p> 
                            </div>
                            {failedAuthMsg}
                            <div className="form-group">{loginButton}</div>
                        </TitleBox>
                    </form>
                </div>
            </div>
        );
    }
})
